document.addEventListener('DOMContentLoaded', () => {

  // força o Dawn a carregar TODOS os deferred-media automaticamente
  document.querySelectorAll('deferred-media').forEach((el) => {
    if (typeof el.loadContent === 'function') {
      el.loadContent();
    }
  });

  // quando os vídeos existirem, aplica autoplay
  const observer = new MutationObserver(() => {
    const videos = document.querySelectorAll('.product__media video');

    videos.forEach((v) => {
      v.muted = true;
      v.playsInline = true;
      v.autoplay = true;
      v.loop = true;
      v.play().catch(()=>{});
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
